import { useEffect, useState } from "react";
import CorporateActionDropDown from "../../ui/dropDowns/CorporateActionDropDown";
import MobileFilter from "../../ui/MobileFilter";
import ScripsDropDownCellTableData from "../../ui/dropDowns/ScripsDropDownCellTableData";
import useFormatedDropdownData from "../../../utils/formatDropdownData";
import BrokerDropdown from "../../ui/tableDataDropdowns/BrokerDropdown";
import DematDropdown from "../../ui/tableDataDropdowns/DematDropdown";

const EligibleHolding = ({
  dataFetching,
  scrip,
  setFilterData,
  isFilter,
  setIsFilter,
  brokerData,
}) => {
  let [value, setValue] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [dematData, setDematData] = useState([]);
  const [dematDataMob, setDematDataMob] = useState([]);

  const { data: broker } = useFormatedDropdownData(
    brokerData,
    "broker_id",
    "broker_name",
  );

  useEffect(() => {
    setDematData([]);
    if (selectedValues?.id) {
      const filterDemat = brokerData?.filter(
        (item) => item.broker_id === Number(selectedValues?.id),
      );
      setDematDataMob(filterDemat);
    } else {
      setDematDataMob([]);
    }
  }, [selectedValues, brokerData]);

  const { data: brokerDemat } = useFormatedDropdownData(
    dematDataMob,
    "demat_id",
    "demat_name",
  );

  const { data: scriptData } = useFormatedDropdownData(scrip);

  useEffect(() => {
    setFilterData(value);
  }, [value]);

  const corporateAction = [
    { value: "B", label: "Bonus" },
    { value: "S", label: "Split" },
    { value: "R", label: "Reduction" },
    { value: "C", label: "Consolidation" },
    { value: "A", label: "Merger" },
    { value: "X", label: "Demerger" },
    { value: "D", label: "Dividend" },
    { value: "G", label: "Right" },
  ];

  const handleApplyFilters = (selectedValues) => {
    setFilterData({
      id: selectedValues?.id,
      demat_id: selectedValues?.demat_id,
      action: selectedValues?.action,
      scrip_name: selectedValues?.scrip_name,
    });
  };

  const eligibleHoldingFilters = [
    {
      name: "id",
      label: "Broker Name",
      type: "searchable",
      options: broker,
    },
    {
      name: "demat_id",
      label: "Demat Name",
      type: "searchable",
      options: brokerDemat?.filter((item) => {
        if (selectedValues?.name !== "Other Broker") {
          return (
            item.value !== "Other Demat - CDSL" &&
            item.value !== "Other Demat - NSDL"
          );
        } else {
          return true;
        }
      }),
    },
    {
      name: "scrip_name",
      label: "Scrip Name",
      type: "searchable",
      options: scriptData,
    },
    {
      name: "action",
      label: "Corporate Action",
      type: "select",
      options: corporateAction,
    },
  ];

  return (
    <div className="relative flex items-baseline gap-2">
      <div className="mb-8 w-full items-baseline gap-8 max-sm:hidden md:flex">
        <div className="flex w-full gap-8">
          <div className=" flex w-full items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2 ">
              <label>Broker Name</label>
              <BrokerDropdown
                data={brokerData}
                setDematData={setDematData}
                valueKey={"broker_id"}
                displayKey={"broker_name"}
                filterKey={"id"}
                setFilter={setValue}
              />{" "}
            </div>
          </div>

          <div className=" flex w-full items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2 ">
              <label>Demat Name</label>
              <DematDropdown
                data={dematData}
                valueKey={"demat_id"}
                displayKey={"demat_name"}
                filterKey={"demat_id"}
                setFilter={setValue}
              />
            </div>
          </div>
        </div>
        <div className="flex w-full gap-8">
          <div className=" flex w-full items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2 ">
              <label>Corporate Action</label>
              <CorporateActionDropDown setValue={setValue} />
            </div>
          </div>

          <div className=" flex w-full items-stretch gap-4 text-neutral-600">
            <div className="flex w-full  flex-col gap-2 ">
              <label>Scrip Name</label>
              <ScripsDropDownCellTableData
                dataFetching={dataFetching}
                scripData={scrip}
                setValue={setValue}
              />
            </div>
          </div>
        </div>

        <div className="flex w-1/2 gap-8 max-xl:hidden">
          <div className=" flex w-full items-stretch gap-4 text-neutral-600 max-xl:hidden"></div>
        </div>
      </div>
      {isFilter && (
        <MobileFilter
          filters={eligibleHoldingFilters}
          onApply={handleApplyFilters}
          onClose={() => setIsFilter(false)}
          isFilter={isFilter}
          setSelectedValues={setSelectedValues}
          selectedValues={selectedValues}
        />
      )}
    </div>
  );
};

export default EligibleHolding;
